import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'member-list',
  templateUrl: './member-list.component.html',
  styleUrls: ['./member-list.component.scss'],
  animations: [slide]
})
export class MemberListComponent implements OnInit {
  members:  FirebaseListObservable<any[]>;
  selectedMember: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  userType: string;
  userLevel: number;

  constructor(
    private router: Router,
    private dbService: DBService
  ) { }

  ngOnInit() {
    switch(this.router.url) {
      case '/members':
        this.members = this.dbService.getMembers();
        this.userType = 'member';
        break;

      case '/vendors':
        this.userType = 'vendor';
        this.members = this.dbService.getVendors();
        break;
    }
  }

  onAddMemberClicked() {
    this.selectedMember = null;
    this.showModalBg = true;
    this.showFormModal = true;
  }


  showMember(member: any) {
    if (this.userType == 'vendor') {
      this.router.navigate([`/vendors/${member.$key}`]);
    } else {
      this.router.navigate([`/members/${member.$key}`]);
    }
  }

  userLevelType(member) {
    switch(member.userLevel) {
      case 0:
        return 'Vendor';
      case 1:
        return 'Member';
      case 2:
        return 'Owner';
      case 3:
        return 'Guest';
    }
  }

  onEditClicked(member, event) {
    event.stopPropagation();
    this.selectedMember = member;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteClicked(member, event) {
    event.stopPropagation();
    this.showModalBg = true;
    this.showDeleteModal = true;
    this.selectedMember = member;
  }

  onConfirmDelete() {
    this.onHideDeleteModal();
    this.dbService.deleteMember(this.selectedMember.$key);
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

  onHideFormModal() {
    this.showModalBg = false;
    this.showFormModal = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/members/member-list/member-list.component.ts